import { j as t } from "./index58.mjs";
import { useMantineTheme as x, Avatar as l, Skeleton as N } from "@mantine/core";
import { forwardRef as h } from "react";
import g from "./index60.mjs";
import { Tooltip as j } from "./index17.mjs";
import { useElementSize as b } from "./index61.mjs";
function i(s) {
  const o = [
    "blue",
    "cyan",
    "grape",
    "red",
    "pink",
    "violet",
    "green",
    "lime",
    "teal",
    "indigo",
    "yellow",
    "orange"
  ], a = g(s.id), e = Math.floor(a() * o.length);
  return o[e];
}
const R = h((s, o) => {
  const a = x(), { user: e, bordered: m, placeholder: c, tooltip: d, ...r } = s, { ref: f, height: p } = b();
  if (!e && c)
    return /* @__PURE__ */ t.jsx(
      l,
      {
        radius: "xl",
        ...r,
        classNames: { placeholder: "bg-black", ...r.classNames }
      }
    );
  if (!e)
    return /* @__PURE__ */ t.jsx(
      N,
      {
        ref: o,
        circle: !0,
        height: p,
        className: `flex-none -ml-1 ${r.className}`,
        children: /* @__PURE__ */ t.jsx(l, { ref: f, ...r })
      }
    );
  const u = {
    radius: "xl",
    src: e.avatar,
    color: i(e)
  }, n = /* @__PURE__ */ t.jsx(
    l,
    {
      ref: o,
      styles: {
        root: {
          border: m ? `1.5px solid ${a.colors[i(e)][6]} !important` : ""
        }
      },
      ...u,
      ...r,
      className: `rounded-full ${r.className}`,
      children: e.firstName && e.lastName ? e.firstName[0] + e.lastName[0] : null
    }
  );
  return d ? /* @__PURE__ */ t.jsx(j, { className: "w-fit", position: "top", label: e.displayName, children: n }) : n;
});
export {
  R as Avatar,
  i as getUserColor
};
